import { addCloseButtonToAllAirportsDropdownLists } from '@/modules/customizations/airport'
import ChildrenBirthdayValidator from '@/modules/search/ChildrenBirthdayValidator'
import * as events from '@/events'

const $ = require('jquery')
const moment = require('moment')

const { SELECTOR, BREAKPOINT } = require('./api')
const customScrollbar = require('./customScrollbar')
const FORMS = require('./forms')
const Overlay = require('./overlay')
const OverlayLoader = require('./overlayLoader')
const queryString = require('./queryString')

const DEFAULT_FILTER_DATES = {
  FROM: '19000101',
  TO: '19000201',
}

// =========================================================================
// Form main offer search
// =========================================================================
const formMainOfferSearch = {
  _selectorForCustomSelectPicker: [ {
    element: '.main-search__filters .custom-select-offer-type',
    noneSelectedText: 'Rodzaj oferty',
    selectedCount: 'count > 2',
    countSelectedText: 'wybrano {0} rodzaje oferty',
    queryStringKeyName: 'OfferType',
  },
  {
    element: '.main-search__filters .custom-select-hotel-standard',
    noneSelectedText: 'Standard hotelu',
    selectedCount: 'count > 2',
    countSelectedText: 'wybrano {0} standardy hotelu',
    queryStringKeyName: 'HotelStandard',
  },
  {
    element: '.main-search__filters .custom-select-beach',
    noneSelectedText: 'Plaża',
    selectedCount: 'count > 2',
    countSelectedText: 'wybrano {0} typy/ow plaż',
    queryStringKeyName: 'Beach',
  },
  {
    element: '.main-search__filters .custom-select-sports-entertainment',
    noneSelectedText: 'Sport i relaks',
    selectedCount: 'count > 2',
    countSelectedText: 'wybrano {0} opcji sportow i rozrywki',
    queryStringKeyName: 'SportsEntertainment',
  },
  {
    element: '.main-search__filters .custom-select-for-children',
    noneSelectedText: 'Dla dzieci',
    selectedCount: 'count > 2',
    countSelectedText: 'wybrano {0} opcje/i dla dzieci',
    queryStringKeyName: 'ForChildren',
  },
  {
    element: '.main-search__filters .custom-select-hotel-categories',
    noneSelectedText: 'Kategorie hotelowe',
    selectedCount: 'count > 2',
    countSelectedText: 'wybrano {0} opcje/i kategorii hotelowych',
    queryStringKeyName: 'HotelCategory',
  },
  {
    element: '.main-search__filters .custom-select-amenities',
    noneSelectedText: 'Udogodnienia',
    selectedCount: 'count > 2',
    countSelectedText: 'wybrano {0} opcje/i udogodnień',
    queryStringKeyName: 'Amenities',
  },
  {
    element: '.main-search__filters .custom-select-attractions',
    noneSelectedText: 'Atrakcje',
    selectedCount: 'count > 2',
    countSelectedText: 'wybrano {0} opcje/i atrakcji',
    queryStringKeyName: 'Attractions',
  },
  {
    element: '.main-search__filters .custom-select-board-standards',
    noneSelectedText: 'Wyżywienie',
    selectedCount: 'count > 2',
    countSelectedText: 'wybrano {0} opcje/i atrakcji',
    queryStringKeyName: 'BoardStandards',
  },
  ],

  _arritemsRadioList: [
    { element: '.custom-select-duration' },
    { element: '.custom-select-price-person' },
  ],

  common () {
    const btnCloseFormSearchSimple = SELECTOR.MAIN_SEARCH_SIMPLE.find('.close-form')
    const btnCloseFormSearchAdv = SELECTOR.MAIN_SEARCH_ADVANCED.find('.close-form')
    const elemForm = function(parentElem) {
      return parentElem.parent().find('form')
    }

    // =====================================================================
    // Build close button for dropdowns
    // =====================================================================
    $(document).on('click', '.dropdown-menu .close', function() {
      log.debug('formMainOfferSearch.js / common - closing dropdown', $(this).closest('.dropdown-menu'))
      $(this).closest('.dropdown-menu').dropdown('toggle')
    })

    btnCloseFormSearchSimple.on('click', function() {
      $(this).hide()
      //ElemForm( $(this) ).hide()
      $('.offer-search-simple > div[class*=" custom-select-"]').hide()
      $('.offer-search-simple > div.custom-select-country').show()
      $('.offer-search-simple > .form-submit-border').hide()
    })

    btnCloseFormSearchAdv.on('click', function() {
      SELECTOR.MAIN_SEARCH_ADVANCED.removeClass('active')

      $('body').removeClass('open-filters')
      Overlay.removeFrom($('body'))

      $(this).hide()
      elemForm(btnCloseFormSearchAdv).hide()
      $('.offer-search-advanced').removeAttr('style')
      $('.offer-search-advanced > .form-submit-border').hide()

      $('.offer-search-advanced > div[class*=" custom-select-"]').hide()
      $('.offer-search-advanced > .main-search__filters').removeClass('show')

      SELECTOR.MAIN_SEARCH_ADVANCED.find('.main-search__filters-btns').addClass('hidden-xs')
    })
  },

  simple () {
    const urlQuery = window.location.search
    const arrQuery = queryString.Get()

    const selectorForCustomSelectPicker = this._selectorForCustomSelectPicker
    // =====================================================================
    // Show loader after click search
    // =====================================================================

    const searchStageBtn = $('.main-search form .form-submit-border input.btn')
    searchStageBtn.on('click', function(e) {
      if ($(this).not(':disabled')) {
        if (new ChildrenBirthdayValidator(e.target.form).validate()) {
          $('body').append(OverlayLoader('big', 'white', true))
          $('.page-modal').hide()
        } else {
          e.preventDefault()
        }
      }
    })
    // =====================================================================
    // Build dropdowns for custom selects
    // =====================================================================
    const $csTitle = $('[class*=" custom-select-"] .section-title')
    const elemsForBuildDropdowns = [
      '.main-search .custom-select-duration > .form-group',
      '.main-search .custom-select-price-person > .form-group',
      '.main-search .custom-select-people > .form-group',
    ]

    for (let i = 0; i < elemsForBuildDropdowns.length; i++) {
      FORMS.helpers.csDropdownBuild($(elemsForBuildDropdowns[i]))
    }

    // =====================================================================
    // Build fake labels
    // =====================================================================
    const elementsFakeLabels = SELECTOR.MAIN_SEARCH.find($csTitle).not('.main-search .custom-select-country .section-title, .main-search .custom-select-airport .section-title')

    FORMS.helpers.csFakeLabel(elementsFakeLabels)
    SELECTOR.MAIN_SEARCH.find('.custom-select-country .section-title, .custom-select-airport .section-title').addClass('section-label')

    // =====================================================================
    // Build dropdowns for custom-select
    // =====================================================================
    const elementsInitDropdowns = [
      '.main-search .custom-select-duration .section-title',
      '.main-search .custom-select-price-person .section-title',
      '.main-search .custom-select-people .section-title',
    ]

    for (let i = 0; i < elementsInitDropdowns.length; i++) {
      FORMS.helpers.csDropdownRun($(elementsInitDropdowns[i]))
    }

    // =====================================================================
    // Custom select price person slider: Variables
    // =====================================================================
    const $csPriceRange = $('.custom-select-price-range')
    const $csPriceRangeInput = $csPriceRange.find('.form-control')
    const valuesPriceRange = {
      min: 0,
      max: 50000,
    }
    let priceRangeType = 'man' // Available values: 'man' (default) || 'couple'

    // =====================================================================
    // Update datepicker instance
    // =====================================================================
    $.datepicker._defaults.onAfterUpdate = null
    const datepickerUpdateDatepicker = $.datepicker._updateDatepicker
    $.datepicker._updateDatepicker = function(inst) {
      datepickerUpdateDatepicker.call(this, inst)

      const onAfterUpdate = this._get(inst, 'onAfterUpdate')
      if (onAfterUpdate) onAfterUpdate.apply((inst.input ? inst.input[0] : null), [ (inst.input ? inst.input.val() : ''), inst ])
    }

    const closeButton = '<div class="custom-select-date__close">×</div>'
    const datepickerError = $('<div class="custom-select-date__title">Brak ofert spełniajacych kryteria</div>')
    const datepickerErrorMessage = $('<div class="custom-select-date__error-msg" />')
    const errorContainer = $('<div class="custom-select-date__error" />')
    const returnDatepicker = $('<div class="custom-select-date__datepicker return" />')

    const errorContent = [
      datepickerError,
      datepickerErrorMessage,
      closeButton,
    ]

    errorContainer.insertAfter('.main-search .custom-select-date .form-group:eq(2)')
    errorContainer.append(errorContent)

    // =====================================================================
    // Custom processing for Duration days to select the right label and
    // default mode the calendar should open in
    // =====================================================================
    if (arrQuery.DurationInterval) {
      // Denote that the default date selector is in date+range mode
      $('.custom-select-date .section-label').html('Wylot od - liczba dni')
      $('.custom-select-date .custom-select-date__container').each(function() {
        this.data.mode = 'date'
      })
    } else {
      // Denote that the default date selector is in from-to mode
      $('.custom-select-date .section-label').html('Wylot od - do')
      $('.custom-select-date .custom-select-date__container').each(function() {
        this.data.mode = 'start'
      })
    }

    const _csDateDatepicker = $('.main-search .custom-select-date .custom-select-date__datepicker')
    let valueForDatepickerDateOfDeparture = null
    let valueForDatepickerDateOfReturn = null

    // =====================================================================
    // Update values in inputs by QueryString
    // =====================================================================
    if (urlQuery) { // && $('body').hasClass('page--listing'))
      // ---------------------------------------------------------------------
      // Get values birthdays of children
      // ---------------------------------------------------------------------
      const _queryStringChild = function(_index, _value) {
        if (_value !== 'null') {
          let child = moment(_value, 'YYYYMMDD')
          child = moment(child).format('DD.MM.YYYY')
          $('.custom-select-people .form-group').slice(2).eq(_index).find('input.form-control').val(child)
        }
      }

      const cases = {
        Dest () {
          $('.custom-select-country').find('select').val(arrQuery.Dest)
          FORMS.helpers.listMiniTags(arrQuery.Dest, '.custom-select-country', 'Dest')
          $('.custom-select-country .section-title').show()
        },
        From () {
          $('.custom-select-airport').find('select').val(arrQuery.From)
          FORMS.helpers.listMiniTags(arrQuery.From, '.custom-select-airport', 'From')
          $('.custom-select-airport .section-title').show()
        },
        Adults () {
          if (SELECTOR.MAIN_SEARCH.exists()) {
            log.debug('Adults', arrQuery.Adults)
            $('.custom-select-people .form-group label + div').eq(0).find('input').val(arrQuery.Adults)
          }
        },
        Children () {
          if (SELECTOR.MAIN_SEARCH.exists()) {
            log.debug('Children', arrQuery.Children)
            $('.custom-select-people .form-group label + div').eq(1).find('input').val(arrQuery.Children)
          }
        },
        Child1 () {
          log.debug('Child1', arrQuery.Child1)
          _queryStringChild(0, arrQuery.Child1)
        },
        Child2 () {
          log.debug('Child2', arrQuery.Child2)
          _queryStringChild(1, arrQuery.Child2)
        },
        Child3 () {
          log.debug('Child3', arrQuery.Child3)
          _queryStringChild(2, arrQuery.Child3)
        },
        Child4 () {
          log.debug('Child4', arrQuery.Child4)
          _queryStringChild(3, arrQuery.Child4)
        },
        Child5 () {
          log.debug('Child5', arrQuery.Child5)
          _queryStringChild(4, arrQuery.Child5)
        },
        Child6 () {
          log.debug('Child6', arrQuery.Child6)
          _queryStringChild(5, arrQuery.Child6)
        },
        DurationInterval () {
          SELECTOR.MAIN_SEARCH.find('.custom-select-date .custom-select-date__container').each(function() {
            this.data.range = arrQuery.DurationInterval[0]
          })

          $('.custom-select-duration .radio').find('input[type="radio"]').each(function() {
            $(this).attr('checked', false)
          })
          if (arrQuery.DurationInterval != 'null') {
            const DurationIntervalRadioButton = $('.custom-select-duration .form-group').eq(0).find('input[type="radio"]').filter(`[value="${arrQuery.DurationInterval}"]`)
            const DurationIntervalText = DurationIntervalRadioButton.next('label').text()

            DurationIntervalRadioButton.attr('checked', true).addClass('checked')

            $('.custom-select-duration .section-title')
              .html(DurationIntervalText)
              .prev('.section-label').show()
          }
        },

        // DurationDays () {
        //   SELECTOR.MAIN_SEARCH.find('.custom-select-date .custom-select-date__container').each(function() {
        //     this.data.range = arrQuery.DurationDays[0]
        //   })

        //   $('.custom-select-duration .radio').find('input[type="radio"]').each(function() {
        //     $(this).attr('checked', false)
        //   })
        //   if (arrQuery.DurationDays != 'null') {
        //     const DurationDaysRadioButton = $('.custom-select-duration .form-group').eq(1).find('input[type="radio"]').filter(`[value="${arrQuery.DurationDays}"]`)
        //     // const DurationDaysText = DurationDaysRadioButton.next('label').text()

        //     DurationDaysRadioButton.attr('checked', true).addClass('checked')

        //     // $('.custom-select-duration .section-title')
        //     //   .html(DurationDaysText)
        //     //   .prev('.section-label').show()
        //   }
        // },

        DateOfDeparture () {
          SELECTOR.MAIN_SEARCH.find('.custom-select-date .custom-select-date__container').each(function() {
            this.data.selectedStart = moment(arrQuery.DateOfDeparture[0], 'YYYYMMDD')
          })
        },
        DateOfReturn () {
          SELECTOR.MAIN_SEARCH.find('.custom-select-date .custom-select-date__container').each(function() {
            this.data.selectedEnd = moment(arrQuery.DateOfReturn[0], 'YYYYMMDD')
          })
        },
        PriceFrom () {
        },
        PriceTo () {
        },
        PriceType () {
          if (this.PriceFrom && this.PriceTo) {
            $csPriceRangeInput.val(`${arrQuery.PriceFrom}:${arrQuery.PriceTo}:${arrQuery.PriceType}`)
          }
        },
        OfferType () {
          log.debug('OfferType', arrQuery.OfferType)
          SELECTOR.MAIN_SEARCH.find(`${selectorForCustomSelectPicker[0].element} select`).val(arrQuery.OfferType)
        },
        HotelStandard () {
          log.debug('HotelStandard', arrQuery.HotelStandard)
          SELECTOR.MAIN_SEARCH.find(`${selectorForCustomSelectPicker[1].element} select`).val(arrQuery.HotelStandard)
        },
        Beach () {
          log.debug('Beach', arrQuery.Beach)
          SELECTOR.MAIN_SEARCH.find(`${selectorForCustomSelectPicker[2].element} select`).val(arrQuery.Beach)
        },
        SportsEntertainment () {
          log.debug('SportsEntertainment', arrQuery.SportsEntertainment)
          SELECTOR.MAIN_SEARCH.find(`${selectorForCustomSelectPicker[3].element} select`).val(arrQuery.SportsEntertainment)
        },
        ForChildren () {
          log.debug('ForChildren', arrQuery.ForChildren)
          SELECTOR.MAIN_SEARCH.find(`${selectorForCustomSelectPicker[4].element} select`).val(arrQuery.ForChildren)
        },
        HotelCategories () {
          log.debug('HotelCategory', arrQuery.HotelCategory)
          SELECTOR.MAIN_SEARCH.find(`${selectorForCustomSelectPicker[5].element} select`).val(arrQuery.HotelCategory)
        },
        Amenities () {
          log.debug('Amenities', arrQuery.Amenities)
          SELECTOR.MAIN_SEARCH.find(`${selectorForCustomSelectPicker[6].element} select`).val(arrQuery.Amenities)
        },
        Attractions () {
          log.debug('Attractions', arrQuery.Attractions)
          SELECTOR.MAIN_SEARCH.find(`${selectorForCustomSelectPicker[7].element} select`).val(arrQuery.Attractions)
        },
        BoardStandards () {
          log.debug('BoardStandards', arrQuery.BoardStandards)
          SELECTOR.MAIN_SEARCH.find(`${selectorForCustomSelectPicker[8].element} select`).val(arrQuery.BoardStandards)
        },
      }

      const queryKeys = Object.keys(cases)

      for (const key1 in arrQuery) {
        if (arrQuery.hasOwnProperty(key1)) {
          for (let i = 0; i < queryKeys.length; i++) {
            if (key1 == queryKeys[i]) cases[key1]()
          }
        }
      }

      // ---------------------------------------------------------------------
      // Set start range of dates on datepicker
      // ---------------------------------------------------------------------
      if (arrQuery.DateOfDeparture && arrQuery.DateOfReturn) {
        DEFAULT_FILTER_DATES.FROM = arrQuery.DateOfDeparture[0]
        DEFAULT_FILTER_DATES.TO = arrQuery.DateOfReturn[0]

        valueForDatepickerDateOfDeparture = moment((moment(DEFAULT_FILTER_DATES.FROM).unix() * 1000))._i
        valueForDatepickerDateOfReturn = moment((moment(DEFAULT_FILTER_DATES.TO).unix() * 1000))._i
      } else {
        valueForDatepickerDateOfDeparture = -1
        valueForDatepickerDateOfReturn = -1
      }

      // ---------------------------------------------------------------------
      // Check radio price person
      // ---------------------------------------------------------------------
      if (arrQuery.PriceFrom && arrQuery.PriceTo) {
        // With query string
        FORMS.helpers.setPriceRange(arrQuery.PriceFrom[0], arrQuery.PriceTo[0], valuesPriceRange)
        if (arrQuery.PriceType) {
          priceRangeType = arrQuery.PriceType[0]
        }
        $csPriceRangeInput.val(`${arrQuery.PriceFrom[0]}:${arrQuery.PriceTo[0]}${priceRangeType}`)
      } else {
        // Without query string
        if ($csPriceRangeInput.exists()) {
          $csPriceRangeInput.val(`${valuesPriceRange.min}:${valuesPriceRange.max}${priceRangeType}`)
        }
      }
    } else {
      // -------------------------------------------------------------------
      // Set start range of dates on datepicker
      // -------------------------------------------------------------------
      valueForDatepickerDateOfDeparture = -1
      valueForDatepickerDateOfReturn = -1
    }

    // =====================================================================
    // Custom select price person slider
    // =====================================================================
    const csPriceRangeBuild = () => {
      $csPriceRange.find('div')
        .append(`
          <div class="custom-select-price-range__slider">
            <span class="custom-select-price-range__label--start">0 zł</span>
            <span class="custom-select-price-range__label--end">50 000 zł</span>
          </div>
          <div class="custom-select-price-range__tooltip"></div>
        `)
    }    
    const csPriceRangeTooltipContent = function(valuePrice) {
      const content = $(
        `<div class="price-value"><span class="f-gothamBook-normal f-size10">Cena</span><span class="f-gotham-bold f-size14"><span class=" price-value__value">${valuePrice}</span> <i class="f-gothamBook-normal f-size11">zł</i></span></div>` +
        '<div class="price-type" role="group"><span role="button" class="custom-icon--man f-size18"></span><span role="button" class="custom-icon--couple f-size18"></span></div>')
      return content
    }

    csPriceRangeBuild()
    const priceRangeValues = $csPriceRangeInput.val()
    const $csPriceRangeSlider = $('.custom-select-price-range__slider')
    const $csPriceRangeTooltip = $('.custom-select-price-range__tooltip')
    $csPriceRangeTooltip.html(csPriceRangeTooltipContent())

    if (urlQuery && arrQuery.PriceType) {
      priceRangeType = arrQuery.PriceType[0]
    }
    // -------------------------------------------------------------------
    // Slider range
    // -------------------------------------------------------------------
    $csPriceRangeSlider.slider({
      animate: 'fast',
      range: true,
      min: valuesPriceRange.min,
      max: valuesPriceRange.max,
      values: [ valuesPriceRange.min, valuesPriceRange.max ],
      slide (event, ui) {
        const delay = function() {
          $csPriceRangeTooltip.find('.price-value__value').text(ui.value)
          $csPriceRangeTooltip.show().css({
            top: 20,
            left: ui.handle.offsetLeft - 34,
          })
        }
        setTimeout(delay, 5)
      },
      stop (event, ui) {
        queryString.Update('PriceFrom', ui.values[0])
        queryString.Update('PriceTo', ui.values[1])
        $csPriceRangeInput.val(`${ui.values[0]}:${ui.values[1]};${priceRangeType}`)

        FORMS.helpers.setPriceRange(ui.values[0], ui.values[1], valuesPriceRange)

        log.debug('input values:', $csPriceRangeInput.val())
      },
    })

    // -------------------------------------------------------------------
    // Set value for price type
    // -------------------------------------------------------------------
    if (urlQuery && arrQuery.PriceType) {
      priceRangeType = arrQuery.PriceType[0]
    }

    // Set values to slider based on values of input range slider
    if (arrQuery.PriceFrom && arrQuery.PriceTo) {
      const _setValuesSlider = {
        From: FORMS.helpers.getRangeValues(priceRangeValues, 'From'),
        To: FORMS.helpers.getRangeValues(priceRangeValues, 'To'),
      }
      log.debug('Set values to slider:', _setValuesSlider)
      $csPriceRangeSlider.slider('option', 'values', [ _setValuesSlider.From, _setValuesSlider.To ])
    }

    // Set active icon for price type
    const priceRangeTypeClass = `custom-icon--${priceRangeType}`
    if ($('.price-type span').hasClass(priceRangeTypeClass)) {
      $('.price-type span').filter(`.${priceRangeTypeClass}`).addClass('active')
    }
    // -------------------------------------------------------------------
    // Change type of price
    // -------------------------------------------------------------------
    $(document).on('click', '.price-type span', function() {
      $(this).siblings().removeClass('active')

      const itemClasses = $(this).addClass('active').attr('class').match(/custom-icon[\w-]*\b/)[0]
      priceRangeType = itemClasses.split('--').pop()

      queryString.Update('PriceType', priceRangeType)
      if (arrQuery.PriceType) {
        arrQuery.PriceType[0] = priceRangeType
      }

      const csPriceRangeSliderValues = $csPriceRangeSlider.slider('option', 'values')

      $csPriceRangeInput.val(`${csPriceRangeSliderValues[0]}:${csPriceRangeSliderValues[1]};${priceRangeType}`)
    })

    // =====================================================================
    // Custom select date
    // =====================================================================
    const csDateDateFormat = 'dd.mm.yy'
    let d1 = valueForDatepickerDateOfDeparture
    let d2 = valueForDatepickerDateOfReturn
    const closeDatepicker = function() {
      events.closeCalendars()
    }
    const closeError = function() {
      errorContainer.removeClass('show')
    }
    const updateValues = function() {
      const _d1 = d1 ? $.datepicker.formatDate(csDateDateFormat, new Date(d1), {}) : null
      const _d2 = d2 ? $.datepicker.formatDate(csDateDateFormat, new Date(d2), {}) : null

      SELECTOR.MAIN_SEARCH.find('.custom-select-date .form-group:eq(0) .form-control').val(_d1)
      SELECTOR.MAIN_SEARCH.find('.custom-select-date .form-group:eq(1) .form-control').val(_d2)

      const _d1ToQueryString = moment(_d1, 'DD.MM.YYYY').format('YYYYMMDD')
      const _d2ToQueryString = moment(_d2, 'DD.MM.YYYY').format('YYYYMMDD')

      // -------------------------------------------------
      // Update queryString DateOfDeparture
      // -------------------------------------------------
      if (d1) {
        queryString.Update('DateOfDeparture', _d1ToQueryString)
      } else {
        queryString.Remove('DateOfDeparture')
      }

      // -------------------------------------------------
      // Update queryString DateOfReturn
      // -------------------------------------------------
      if (d2) {
        queryString.Update('DateOfReturn', _d2ToQueryString)
      } else {
        queryString.Remove('DateOfReturn')
      }
      // -------------------------------------------------
    }

    d1 = (d1 === -1) ? null : d1
    d2 = (d2 === -1) ? null : d2

    $(document).on('click', '[class*="custom-select-"] .dropdown-toggle', function() {
      if (errorContainer.hasClass('show')) {
        closeError()
      } else {
        closeDatepicker()
      }
    })

    _csDateDatepicker.on('click', function(e) {
      e.stopPropagation()
    })

    $('.custom-select-date__close').click(function(e) {
      e.stopPropagation()
      if (errorContainer.hasClass('show')) {
        closeError()
      }
    })

    $(document).on('click', function(e) {
      if ($(e.target).closest('.calendar').length == 0) {
        if (errorContainer.hasClass('show')) {
          closeError()
        }
      }
    })

    $('.section-title').on('click', function() {
      if (errorContainer.hasClass('show')) {
        closeError()
      } else {
        closeDatepicker()
      }
    })

    $('.custom-select-date .section-title').on('click', function() {
      $('div[class*="custom-select-"],.bootstrap-select').removeClass('open')
    })

    $('.custom-select-date__label .close').click(function() {
      const isDeparture = $(this).parents('.departure').length

      if (isDeparture) {
        d1 = null
        $('.departure .custom-select-date__label span').text('')
      } else {
        d2 = null
        returnDatepicker.addClass('date-not-selected')
        $('.return .custom-select-date__label span').text('')
      }

      updateValues()
    })

    // =====================================================================
    // Custom select country
    // =====================================================================
    const $csCountry = SELECTOR.MAIN_SEARCH.find('.custom-select-country')
    const $csCountryTitle = SELECTOR.MAIN_SEARCH.find('.custom-select-country .section-title')

    $csCountry.find('select')
      .selectpicker({
        'header': 'Wybierz kierunki podróży',
        'selectOnTab': true,
        'noneSelectedText': 'Dokąd chcesz pojechać?',
        'selectedTextFormat': 'count > 2',
        countSelectedText (num) {
          if (num > 1) {
            return 'wybrano {0} miejsc'
          } else {
            return ''
          }
        },
        'deselectAllText': 'Wyczyść',
        'selectAllText': 'Wybierz',
        'actionsBox': true,
        'hideOnClickSelectAll': true,
        'iconBase': 'custom-checkbox',
        'tickIcon': 'custom-checkbox-checked',
        'size': false,
      })
      .on('shown.bs.select', function() {
        _csDateDatepicker.removeClass('show')
      })
      .on('changed.bs.select', function(e) {
        const selected = $(e.currentTarget).val()

        log.debug(selected)
        if (selected !== null) {
          $csCountryTitle.fadeIn()
          const lengthTags = selected.length
          if (lengthTags > 0) {
            FORMS.helpers.listMiniTags(selected, '.custom-select-country', 'Dest')
          }

          queryString.Update('Dest', selected)
        } else {
          $(this).selectpicker('noneSelectedText', 'Dokąd chcesz pojechać?')
          $(this).selectpicker('refresh')

          $csCountry.find('.list-mini-tags').fadeOut(300, function() {
            $(this).remove()
          })
          $csCountryTitle.fadeOut()

          queryString.Remove('Dest')
        }
      })

    // =====================================================================
    // Custom select airport
    // =====================================================================
    const $csAirport = SELECTOR.MAIN_SEARCH.find('.custom-select-airport')
    const $csAirportTitle = SELECTOR.MAIN_SEARCH.find('.custom-select-airport .section-title')

    $csAirport.find('select')
      .selectpicker({
        'noneSelectedText': 'Wylot z...',
        'selectedTextFormat': 'count > 2',
        countSelectedText (num) {
          if (num > 1) {
            return 'wybrano {0} lotniska'
          } else {
            return ''
          }
        },
        'iconBase': 'custom-checkbox',
        'tickIcon': 'custom-checkbox-checked',
      })
      .on('shown.bs.select', function() {
        _csDateDatepicker.removeClass('show')
      })
      .on('changed.bs.select', function(e) {
        const selected = $(e.currentTarget).val()

        if (selected !== null) {
          $csAirportTitle.fadeIn()
          const lengthTags = selected.length
          //Var getTags = selected.slice(0, 5)
          if (lengthTags > 0) {
            FORMS.helpers.listMiniTags(selected, '.custom-select-airport', 'From')
          }

          queryString.Update('From', selected)
        } else {
          $(this).selectpicker('noneSelectedText', 'Wylot z...')
          $(this).selectpicker('refresh')

          $csAirport.find('.list-mini-tags').fadeOut(300, function() {
            $(this).remove()
          })
          $csAirportTitle.fadeOut()

          queryString.Remove('From')
        }
      })

    addCloseButtonToAllAirportsDropdownLists()

    // =====================================================================
    // Custom select duration
    // =====================================================================
    FORMS.customSelect.duration(SELECTOR.MAIN_SEARCH, true)
    $('.custom-select-duration', SELECTOR.MAIN_SEARCH).find('.dropdown-menu').perfectScrollbar()

    // =====================================================================
    // Custom select people
    // =====================================================================
    if (SELECTOR.MAIN_SEARCH.exists()) {
      FORMS.customSelect.people.init(SELECTOR.MAIN_SEARCH, true, false, false)
    }

    // =====================================================================
    // Custom select price person
    // =====================================================================
    FORMS.customSelect.pricePerson({
      parentSel: SELECTOR.MAIN_SEARCH,
      priceRangeSlider: true,
      updateQueryString: true,
      valuesPriceRange,
    })

    function addFilterDropdownScroll () {
      // Rebuild scrollbar on clicked dropdown block
      if (window.innerWidth > BREAKPOINT.TABLET) {
        $('.main-search__filters').on('click', '.dropdown-toggle', function() {
          return customScrollbar.rebuildScroll($(this).next())
        })
      }
    }

    addFilterDropdownScroll()
    $(window).resize(addFilterDropdownScroll)
  },

  advanced () {
    const _csDateDatepicker = $('.main-search .custom-select-date .custom-select-date__datepicker, .form-filters-offers .custom-select-date .custom-select-date__datepicker')
    const selectorForCustomSelectPicker = this._selectorForCustomSelectPicker
    const arritemsRadioList = this._arritemsRadioList
    const elementsFakeLabels = SELECTOR.MAIN_SEARCH.find('.main-search__filters .custom-select-average-rating .control-label')
    const filterCopy = $('.main-search form .filterCopy')
    const searchStageBtn = $('.main-search form .form-submit-border input.btn')

    filterCopy.on('click', function() {
      searchStageBtn.trigger('click')
    })

    FORMS.helpers.csFakeLabel(elementsFakeLabels)
    SELECTOR.MAIN_SEARCH.find('.main-search__filters .custom-select-average-rating .control-label').addClass('section-title')

    FORMS.helpers.csDropdownBuild(
      $('.main-search__filters .custom-select-average-rating > .control-label + div')
    )
    FORMS.helpers.csDropdownRun(
      $('.main-search__filters .custom-select-average-rating .section-title')
    )

    for (let i = 0; i < selectorForCustomSelectPicker.length; i++) {
      buildCustomSelectPikcer({
        element: selectorForCustomSelectPicker[i].element,
        noneSelectedText: selectorForCustomSelectPicker[i].noneSelectedText,
        selectedCount: selectorForCustomSelectPicker[i].selectedCount,
        countSelectedText: selectorForCustomSelectPicker[i].countSelectedText,
        queryStringKeyName: selectorForCustomSelectPicker[i].queryStringKeyName,
      })
    }

    function buildCustomSelectPikcer (config) {
      const $customSelectpicker = $(config.element)
      const $customSelectpickerTitle = $(`${config.element} .section-title`)

      $customSelectpicker.find('select')
        .selectpicker({
          'noneSelectedText': config.noneSelectedText,
          'selectedTextFormat': config.selectedCount,
          countSelectedText (num) {
            if (num > 1) {
              return config.countSelectedText
            } else {
              return ''
            }
          },
          'iconBase': 'custom-checkbox',
          'tickIcon': 'custom-checkbox-checked',
        })
        .on('shown.bs.select', function() {
          _csDateDatepicker.removeClass('show')
        })
        .on('changed.bs.select', function(e) {
          const selected = $(e.currentTarget).val()
          if (selected !== null) {
            $customSelectpickerTitle.fadeIn()
            queryString.Update(config.queryStringKeyName, selected)
          } else {
            $(this).selectpicker('noneSelectedText', config.noneSelectedText)
            $(this).selectpicker('refresh')
            $customSelectpickerTitle.hide()
            queryString.Remove(config.queryStringKeyName)
          }
        })
    }

    // =====================================================================
    // Show/hide and clear values filters section
    // =====================================================================
    const $mainSearchFilters = $('.main-search__filters')
    const arrSelectItemsForClear = function() {
      const _arrSelectItemsForClear = []
      for (let i = 0; i < selectorForCustomSelectPicker.length; i++) {
        _arrSelectItemsForClear.push(selectorForCustomSelectPicker[i].element)
      }

      _arrSelectItemsForClear.unshift('.main-search--advanced .custom-select-country')
      _arrSelectItemsForClear.unshift('.main-search--advanced .custom-select-airport')

      return _arrSelectItemsForClear
    }()

    const setupFiltersForDesktop = () => {
      toggleAdvancedFilters()
      $('.stage .main-search--advanced').toggleClass('main-search--static')
    }

    const setupFiltersForTablet = () => {
      toggleAdvancedFilters()
    }

    const setupFiltersForMobile = () => {
      SELECTOR.MAIN_SEARCH.removeClass('active')

      $('body').removeClass('open-filters')
      Overlay.removeFrom($('body'))

      $('.close-form').hide()
      $('.close-form').parent().find('form').hide()
      $('.offer-search-advanced').removeAttr('style')
      $('.offer-search-advanced > .form-submit-border').hide()

      $('.offer-search-advanced > div[class*=" custom-select-"]').hide()
      $('.offer-search-advanced > .main-search__filters').removeClass('show')

      $('.main-search__filters-btns').addClass('hidden-xs')
    }

    const toggleAdvancedFilters = () => {
      $mainSearchFilters.toggleClass('show')

      if ($mainSearchFilters.hasClass('show')) {
        $('.stage > div + .main-search--advanced').css('bottom', '-229px')
        $('.stage .main-search--advanced > .container').css('padding-bottom', 0)
        $('.main-search__filters-btns').css('margin-top', '-40px')
      } else {
        $('.main-search__filters-btns, .stage > div + .main-search--advanced, .stage .main-search--advanced > .container').removeAttr('style')
      }
    }

    const setAdvancedFiltersForBreakpoint = () => {
      const screen = window.innerWidth
      if (screen < BREAKPOINT.TABLET) setupFiltersForMobile()
      else if (screen < BREAKPOINT.DESKTOP) setupFiltersForTablet()
      else setupFiltersForDesktop()
    }

    const advancedFilters = document.querySelector('.main-search--advanced .filters-btn__sh')
    if (advancedFilters) advancedFilters.addEventListener('click', setAdvancedFiltersForBreakpoint)

    SELECTOR.MAIN_SEARCH_ADVANCED.find('.filters-btn__clear').on('click', function(e) {
      e.preventDefault()

      // -------------------------------------------------------------------
      // Clear values from radio lists in dropdowns
      for (let i = 0; i < arritemsRadioList.length; i++) {
        const selectorDropdown = SELECTOR.MAIN_SEARCH.find('.dropdown-menu', arritemsRadioList[i].element)
        const selectorParent = SELECTOR.MAIN_SEARCH.find(arritemsRadioList[i].element)
        FORMS.helpers.csRadiosList.radioLabel(selectorDropdown).find('input[type="radio"]').each(function() {
          $(this).attr('checked', false)
          if ($(this).hasClass('checked')) {
            $(this).removeClass('checked')
          }
        })
        FORMS.helpers.csRadiosList.hideSectionTitle(selectorParent)
      }

      // -------------------------------------------------------------------
      // Clear values from cusotm selectpickers in filters
      for (let i = 0; i < arrSelectItemsForClear.length; i++) {
        SELECTOR.MAIN_SEARCH.find(' select', arrSelectItemsForClear[i].element).val('').selectpicker('deselectAll')
      }

      $('.main-search--advanced .custom-select-country, .main-search--advanced .custom-select-airport').find('.list-mini-tags').remove()
      // -------------------------------------------------------------------
      // Clear values from custom-select-date

      const calendar = SELECTOR.MAIN_SEARCH.find('.custom-select-date__container').get(0)
      if (calendar) {
        calendar.data.initializer.reset()
      }

      // -------------------------------------------------------------------
      // Clear values from .custom-select-people
      FORMS.customSelect.people.clearValues(SELECTOR.MAIN_SEARCH, { Adults: 0, Children: 0 }, 0, 0)

      // -------------------------------------------------------------------
      // Clear value .custom-select-price-range
      $('.custom-select-price-range').find('.form-control').val(`${0}:${50000};` + 'man')
      $('.custom-select-price-range__slider').slider('option', 'values', [ 0, 50000 ])

      // Hide price-range tooltip
      $('.custom-select-price-range__tooltip').hide()      

      // -------------------------------------------------------------------
      // Clear values from queryString
      queryString.ClearAll()
      queryString.Update('DateOfDeparture', calendar.data.selectedStart.format('YYYYMMDD'))
      queryString.Update('DateOfReturn', calendar.data.selectedEnd.format('YYYYMMDD'))
      queryString.Remove('PriceFrom')
      queryString.Remove('PriceTo')
      queryString.Remove('PriceType')
      queryString.Remove('DurationInterval')
      queryString.Remove('Amenities')
      queryString.Remove('Attractions')
      queryString.Remove('HotelStandard')
      queryString.Remove('Beach')
      queryString.Remove('SportsEntertainment')
      queryString.Remove('HotelCategory')
      queryString.Remove('ForChildren')
      queryString.Remove('BoardStandards')
    })
  },
}

module.exports = formMainOfferSearch




// WEBPACK FOOTER //
// ./src/modules/formMainOfferSearch.js